export default __webpack_public_path__ + "static/media/konkurs.18a6410a.pdf";